/*
 * @Descripttion:
 * @version    :
 * @Author     : wuyujiang
 * @Date       : 2024-06-23 10:35
 * @LastAuthor : wuyujiang
 * @LastTime   : 2025-05-26 21:53
 * @Version    : v1.00
 * @desc       :
 */
// 主播图标以及背景
function getIcon(level) {
  let obj = {
    icon: "",
    background: "",
  };
  if (!level || level < 10) {
    obj.icon = "anchor0";
    obj.background = "#73B7DA";
  } else if (level < 20) {
    obj.icon = "anchor0";
    obj.background = "#5A91FF";
  } else if (level < 30) {
    obj.icon = "anchor1";
    obj.background = "#5A5AFF";
  } else if (level < 40) {
    obj.icon = "anchor1";
    obj.background = "#7D3CFF";
  } else if (level < 50) {
    obj.icon = "anchor2";
    obj.background = "#9F09EA";
  } else if (level < 60) {
    obj.icon = "anchor2";
    obj.background = "#DF09EA";
  } else if (level < 70) {
    obj.icon = "anchor3";
    obj.background = "#FD0FC1";
  } else if (level < 80) {
    obj.icon = "anchor3";
    obj.background = "#FD178A";
  } else if (level < 90) {
    obj.icon = "anchor4";
    obj.background = "#FD1754";
  } else {
    obj.icon = "anchor4";
    obj.background = "linear-gradient( 270deg, #A305FF 41%, #FF0F6B 100%)";
  }
  return obj;
}
function getUserIcon(level) {
  let obj = {
    icon: "",
    background: "",
  };
  if (!level || level < 10) {
    obj.icon = "user0";
    obj.background = "#92BED1";
  } else if (level < 20) {
    obj.icon = "user1";
    obj.background = "#3FD082";
  } else if (level < 30) {
    obj.icon = "user2";
    obj.background = "#31D4DE";
  } else if (level < 40) {
    obj.icon = "user3";
    obj.background = "#54A4EE";
  } else if (level < 50) {
    obj.icon = "user4";
    obj.background = "#9F81F6";
  } else if (level < 60) {
    obj.icon = "user5";
    obj.background = "#DA64E4";
  } else if (level < 70) {
    obj.icon = "user6";
    obj.background = "#FF9900";
  } else if (level < 80) {
    obj.icon = "user7";
    obj.background = "#FF7438";
  } else if (level < 90) {
    obj.icon = "user8";
    obj.background = "#FE5B51";
  } else {
    obj.icon = "user9";
    obj.background = "#3A2216";
  }
  return obj;
}

function toThousands(num) {
  if (!num) {
    return 0;
  }

  if (typeof num === "string") num = Number(num);
  if (typeof num !== "number" || isNaN(num)) return;
  let numStr = String(num); // 数字字符串
  let [integer, decimal] = numStr.split("."); // 整数部分，小数部分
  // 小数部分处理：四舍五入保留 places 位小数
  // 注意：不能直接使用 toFixed，toFixed 它是一个四舍六入五成双的诡异的方法(也叫银行家算法)，"四舍六入五成双"，最好别用，否则可能会出大问题！

  if (decimal) {
    decimal = decimal.slice(0, 2);
  }
  // 整数部分处理
  let thousandsIntStr = "";
  while (integer.length > 3) {
    thousandsIntStr = "," + integer.slice(-3) + thousandsIntStr;
    integer = integer.slice(0, integer.length - 3);
  }
  thousandsIntStr = integer ? integer + thousandsIntStr : thousandsIntStr;
  let result = decimal ? `${thousandsIntStr}.${decimal}` : thousandsIntStr;
  if (result.startsWith("-,")) result = result.replace("-,", "-");

  return result;
}

export { getIcon, getUserIcon, toThousands };
